import { type HeadingNode, TextAlignment } from '@prezly/story-content-format';
import classNames from 'classnames';
import type { ReactNode } from 'react';

import styles from './Title.module.scss';

interface Props {
    children?: ReactNode;
    node: HeadingNode;
}

export function Title({ children, node }: Props) {
    return (
        <h1
            className={classNames(styles.title, {
                [styles.alignLeft]: node.align === TextAlignment.LEFT,
                [styles.alignCenter]: node.align === TextAlignment.CENTER,
                [styles.alignRight]: node.align === TextAlignment.RIGHT,
            })}
        >
            {children}
        </h1>
    );
}
